export default __webpack_public_path__ + "static/media/calendly.411135d9.png";